<template>
  <v-container>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.back()"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </template>
      <span>Go Back</span>
    </v-tooltip>
    <v-data-table :headers="headers" :items="categories" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="transparent">
          <span class="title font-weight-bold">{{
            $t("stocks.categories")
          }}</span>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                {{ $t("stocks.newCategories") }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.name"
                        :label="$t('stocks.name')"
                      ></v-text-field>
                      <v-text-field
                        type="color"
                        label="Color"
                        v-model="editedItem.color"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  {{ $t("stocks.cancel") }}
                </v-btn>
                <v-btn color="blue darken-1" text @click="save">
                  {{ $t("stocks.save") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline"
                >Are you sure you want to delete this category?
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.color`]="{ item }">
        <v-icon large :color="item.color">mdi-circle</v-icon>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      headers: [
        { text: this.$t("stocks.name"), value: "name" },
        { text: "Color", value: "color" },
        { text: "", value: "actions", sortable: false }
      ],

      editedIndex: -1,
      editedItem: {
        name: "",
        color: ""
      },
      defaultItem: {
        name: "",
        color: ""
      }
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("stocks.newItem")
        : this.$t("stocks.editItem");
    },
    ...mapState("assets", ["categories"])
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    }
  },
  async created() {
    await this.$store.dispatch("assets/bindCategories");
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.categories.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.categories.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      await this.$store.dispatch("deleteDocument", {
        db: `categories`,
        doc: this.editedItem.id
      });
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      if (this.editedIndex > -1) {
        let payload = {
          db: `categories`,
          data: this.editedItem,
          doc: this.editedItem.id
        };

        try {
          await this.$store.dispatch("updateDocument", payload);
          this.$dialog.notify.success(
            "Your new category has been updated successfully",
            {
              position: "top-right",
              timeout: 5000
            }
          );
        } catch (error) {
          this.$dialog.notify.error(error, {
            position: "top-right",
            timeout: 5000
          });
        }
      } else {
        this.editedItem.date = new Date();
        this.editedItem.disabled = false;

        let payload = {
          db: `categories`,
          data: this.editedItem
        };

        try {
          await this.$store.dispatch("addDocument", payload);
          this.$dialog.notify.success(
            "Your new category has been created successfully",
            {
              position: "top-right",
              timeout: 5000
            }
          );
        } catch (error) {
          this.$dialog.notify.error(error, {
            position: "top-right",
            timeout: 5000
          });
        }
      }

      this.close();
    }
  }
};
</script>

<style></style>
